export enum OEEnvironment {
	DEV = 'DEV',
	STAGE = 'STAGE',
	PROD = 'PROD',
}
